const translations = {
  title: 'Nuevo Cuestionario',
  title_edit: 'Editando Cuestionario',
  'questionsStep.title': 'Categorías y preguntas',
  'questionsStep.subtitle': 'Construya la estructura del cuestionario',
  'fieldsStep.name': 'Nombre',
  'fieldsStep.type': 'Tipo',
  'fieldsStep.title': 'Información Básica',
  'fieldsStep.subtitle': 'Complete la información del cuestionario',
  'fieldsStep.allowReview': 'Permite revisión basada en la última actividad',
  'fieldsStep.sendEmail': 'Enviar notificación por email al completar el cuestionario',
  'fieldsStep.usages': 'Voy a utilizar este cuestionario en',
  'fieldsStep.description': 'Descripción',
  'fieldsStep.icon': 'Icono',
  'fieldsStep.requireCheckin': 'Exigir validación de QR Code del local para ejecutar este cuestionario en la app',
  'fieldsStep.allowBulkExecution': 'Permite ejecución en masa',
  'fieldsStep.allowBulkExecutionConditionalLogicHint':
    'Los cuestionarios habilitados para ejecución en masa no pueden utilizar lógicas condicionales.',
  'fieldsStep.allowBulkExecutionConditionalLogicBlocked':
    '🚨 Este cuestionario tiene preguntas con lógicas configuradas. Para permitir la ejecución en masa, es necesario eliminar todas las lógicas del cuestionario. Después de realizar el ajuste, vuelva y active nuevamente esta opción.',
  'fieldsStep.setRuntime': 'Tiempo de ejecución de este cuestionario',
  'fieldsStep.enabledSegwareTestMode': 'Habilitar modo de prueba de Segware',
  'fieldsStep.segwarePermittedExecutionTime': 'Tiempo de ejecución del modo de prueba',
  'fieldsStep.calendarViewActive': 'Agregar color de fondo en el evento del calendario',
  'fieldsStep.calendarViewBgColor': 'Seleccione el color',
  usageForm: 'Formularios',
  usageServiceOrder: 'Actividades',
  usageActionPlan: 'Plan de Acción',
  dragQuestionsHere: 'Arrastre las preguntas aquí',
  addCategory: 'Agregar Categoría',
  clone: 'Clonar',
  remove: 'Eliminar',
  question: 'Pregunta',
  questionSettings: 'Configuraciones de la Pregunta',
  required: 'Obligatorio',
  requiredDocument: 'Documento obligatorio',
  useSavedUserSignature: 'Rellenar con firma del perfil del usuario',
  confidential: 'Confidencial',
  allowNA: 'Permitir N/A',
  allowOnlyQrCodeOperations: 'Permitir solo operaciones vía QR Code',
  displayAsDropdown: 'Mostrar como lista desplegable',
  allowMultipleSelection: 'Permitir selección múltiple',
  noLineBreak: 'No permitir salto de línea',
  useMarkdown: 'Usar markdown',
  dontAllowReview: 'No permitir revisión',
  filterByActivityPlace: 'Filtrar por local de la actividad',
  annotations: 'Anotaciones',
  allowAnnotations: 'Permite anotaciones',
  requiredAnnotations: 'Anotaciones obligatorias',
  'validationCode.title': 'Validación',
  'validationCode.validateWithParentId': 'Validar usando el ID de la actividad padre',
  filterByAdditionalField: 'Filtro por Campo Adicional',
  selectAdditionalField: 'Seleccione el campo adicional',
  selectOperator: 'Seleccione el operador',
  value: 'Valor',
  addFilter: 'Agregar filtro',
  additionalField: 'Campo adicional',
  removeFilter: 'Eliminar filtro',
  folder: 'Carpeta',
  noFolder: 'Sin carpeta',
  calcWarning: 'Este tipo de pregunta no puede ser usado entre categorías diferentes o dentro de bloques.',
  'operator.equal': 'Igual a',
  'operator.notEqual': 'Diferente de',
  'operator.greaterThan': 'Mayor que',
  'operator.lessThan': 'Menor que',
  'operator.lessThanOrEqual': 'Menor o igual a',
  'operator.greaterThanOrEqual': 'Mayor o igual a',
  validationNameRequired: 'Nombre obligatorio',
  validationSelectUsage: 'Seleccione cómo quiere usar el cuestionario',
  validationSelectType: 'Seleccione el tipo del cuestionario',
  validationSelectCalendarColor: 'Seleccione el color de fondo en el evento del calendario',
  validationAddAtLeastOneCategory: 'Por favor agregue al menos una categoría',
  validationGroupsWithoutCategory: 'El cuestionario tiene grupos sin categoría seleccionada',
  validationCategoriesWithoutQuestions: 'Las categorías no pueden quedar sin preguntas',
  validationQuestionsWithoutLabel: 'El cuestionario tiene preguntas sin etiqueta',
  validationInvalidConditions:
    'El cuestionario tiene lógicas o configuración de no conformidades con opciones que ya no existen. Verifique las preguntas de Selección Única y Múltiple Opción.',
  validationQuestionsWithoutOptions: 'El cuestionario tiene preguntas de selección o múltiple opción sin opciones',
  validationEmptyBlocks: 'No se permiten preguntas de bloque vacío',
  validationBlocksInBlocks: 'No se permiten bloques dentro de bloques',
  validationEmptyCalc: 'El cuestionario tiene preguntas de cálculo sin fórmula',
  validationEmptyIntegration: 'El cuestionario tiene preguntas de integración sin configuración',
  selectCategory: 'Seleccione una categoría',
  selectQuestionToEdit: 'Seleccione una pregunta para editarla',
  categoryLabel: 'categoría',
  questionLabel: 'pregunta',
  'removeModal.multipleAutomationsAffected':
    'Las siguientes automatizaciones se verán afectadas por la eliminación de la {{removingType}}',
  'removeModal.singleAutomationAffected':
    'La siguiente automatización se verá afectada por la eliminación de la {{removingType}}',
  'removeModal.confirmContinue': '¿Está seguro de que desea continuar?',
  'removeModal.removeCategoryWarning':
    'Al eliminar esta categoría, todas las preguntas vinculadas serán eliminadas. ¿Está seguro de que desea continuar?',
  ifAnswerIs: 'Si la respuesta es:',
  addLogic: 'Agregar lógica',
  addLogicBlockedByBulkExecution:
    'Los cuestionarios habilitados para ejecución en masa no pueden utilizar lógicas condicionales entre preguntas.',
  updateLogic: 'Actualizar lógica',
  multipleChoiceOptions: 'Opciones de múltiple opción',
  questionInfo: 'Información de la pregunta',
  description: 'Descripción',
  fileOrImage: 'Archivo o Imagen',
  add: 'Agregar',
  noCategoryDefined: 'Sin categoría definida',
  defaultValue: 'Valor inicial',
  removeDefaultValue: 'Eliminar valor inicial',
  calculation: 'Cálculo',
  formula: 'Fórmula',
  calcNote: 'Nota: Utilice números con el siguiente patrón',
  calcMinFieldsRequired: 'Se requieren al menos 2 campos numéricos para obtener un resultado.',
  numericSettings: 'Configuraciones numéricas',
  minValue: 'Valor mínimo',
  maxValue: 'Valor máximo',
  labels: 'Etiquetas',
  'labels.yesNo': 'Sí/No',
  'labels.compliant': 'Conforme',
  'labels.nonCompliant': 'No Conforme',
  'labels.compliantNonCompliant': 'Conforme/No Conforme',
  'labels.approved': 'Aprobado',
  'labels.rejected': 'Rechazado',
  'labels.approvedRejected': 'Aprobado/Rechazado',
  'labels.positive': 'Positivo',
  'labels.negative': 'Negativo',
  'labels.positiveNegative': 'Positivo/Negativo',
  photoSettings: 'Configuraciones de Foto',
  minQuantity: 'Cantidad mín',
  allowPhotos: 'Permite fotos',
  requiredPhotos: 'Fotos obligatorias',
  allowGalleryPhotos: 'Permitir fotos de la galería',
  configurationTags: 'Etiquetas de configuración',
  filters: 'Filtros',
  isNonComplianceWhenAnswerIs: 'Es no conformidad cuando la respuesta sea:',
  removeConfiguration: 'Eliminar configuración',
  configureMask: 'Configurar máscara',
  integration: 'Integración',
  service: 'Servicio',
  field: 'Campo',
  operationType: 'Tipo de operación',
  legacyQuestionTypeTitle: '¡Tipo de pregunta descontinuado!',
  legacyQuestionTypeMessage:
    'Para obtener el mismo resultado, elija la pregunta del tipo **Texto** y aplique la **Máscara** deseada.',
  questionNumber: 'Pregunta #{{number}}',
  addQuestionLabel: 'Agregar etiqueta de la pregunta...',
  containsLogic: 'Contiene lógica',
  questionWithNonComplianceConfig: 'Pregunta con configuración de no conformidad',
  predefinedDefaultValue: 'Valor inicial predefinido',
  questionsRemaining: '🚨 Todavía puede agregar **{{remaining}}** de **{{total}}** preguntas',
  previewMessage: '¿Desea ver cómo quedará el formulario final?',
  preview: 'Previsualizar',
  selectTemplate: 'Seleccione una plantilla',
  'autofill.title': 'Autocompletado',
  'autofill.dataSource': 'Fuente de datos',
  'autofill.sourceUser': 'Perfil del usuario',
  'autofill.sourcePlace': 'Datos del local',
  'autofill.sourceServiceOrder': 'Campos de la actividad',
  'autofill.selectSource': 'Seleccione la fuente',
  'autofill.field': 'Campo (origen)',
  'autofill.editable': 'Campo editable',
  'autofill.updateBase': 'Actualizar en la base',
  'autofill.updateBaseWarning': 'Los cambios del técnico en la app actualizarán el registro del usuario o del local.',
  'autofill.removeConfig': 'Quitar autocompletado'
}

export default translations
